export default {
    required: '必須項目です',
    filled: '必須項目です',
    notEmpty: '空にすることはできません',
    empty: '空でなければなりません',
    minLength: '文字数の最小制限を満たさない',
    maxLength: '指定文字数を超えています',
    rangeLength: '長さは {0} から {1} の間でなければなりません',
    min: '{0} 以上でなければなりません',
    max: '{0} 以下でなければなりません',
    range: '{0} から {1} の間でなければなりません',
    pattern: '無効な形式',
    is: '{0} でなければなりません',
    isNot: '{0} にすることはできません',
    equals: '{0}に等しい必要があります',
    notEquals: '{0} と等しくすることはできません',
    confirmed: '2回入力したパスワードが一致しません',
    includes: '{args} を含める必要があります',
    excludes: '{args} を含めることはできません',
    included: '{args} の値でなければなりません',
    excluded: '{args} の値にすることはできません',
    unique: 'は既に存在します',
    noDuplicates: '重複したアイテムを含めることはできません',
    string: '文字列でなければなりません',
    number: '数値である必要があります',
    numeric: '数値である必要があります',
    integer: '整数でなければなりません',
    decimal: '有効な小数でなければなりません',
    boolean: 'ブール値でなければなりません',
    function: '関数でなければなりません',
    object: 'オブジェクトでなければなりません',
    plainObject: 'プレーンなオブジェクトでなければなりません',
    array: '配列でなければなりません',
    alpha: '英字のみを含めることができます',
    alphaNum: '英数字のみを含めることができます',
    alphaDash: '文字または「_」のみを含めることができます',
    alphaNumDash: '文字、数字の「_」のみを含めることができます',
    alphaSpaces: '文字または空白のみを含めることができます',
    lowerCase: '大文字は禁止',
    upperCase: '小文字は禁止',
    '^az': '小文字で始める必要があります',
    '^az09': '小文字または数字で始める必要があります',
    '^az09_': '小文字、数字、または「_」で始まる必要があります',
    '^azAZ': '文字で始まる必要があります',
    '^azAZ09': '文字または数字で始まる必要があります',
    '^azAZ09_': '文字、数字、または「_」で始まる必要があります',
    az09$: '小文字または数字で終わる必要があります',
    azAZ09$: '文字または数字で終わる必要があります',
    '^09$': '数字を入力してください',
    '^az09$': '小文字または数字のみを含めることができます',
    '^az09-$': '小文字、数字、または「-」のみを含めることができます',
    '^az09-.$': '小文字、数字、「-」または「.」のみを含めることができます。',
    '^azAZ09$': '文字または数字のみを含めることができます',
    '^azAZ09-$': '文字、数字、または「-」のみを含めることができます',
    '^azAZ09_$': '文字、数字、または「_」のみを含めることができます',
    '^azAZ09-_$': '文字、数字、「-」または「_」のみを含めることができます',
    'without--': '「-」は2連続禁止',
    without__: "'_' の 2 つ連続は禁止です",
    email: 'エラーが発生しました。再度ご入力ください',
    ip: '有効な IP である必要があります',
    ipRange: '有効な IP 範囲である必要があります',
    port: '有効なポートである必要があります',
    url: '有効な URL である必要があります',
    macAddress: '有効な MAC アドレスである必要があります',
    md5: '有効な MD5 である必要があります',
    ascii: 'ASCIIコードでなければなりません',
    base32: 'base32 コードである必要があります',
    base64: 'base64 コードである必要があります',
    byteLength: 'バイト長が範囲外です',
    dataURI: '有効な dataURI コードである必要があります',
    magnetURI: '有効な magnetURI コードである必要があります',
    divisibleBy: '{0} で割り切れる必要があります',
    fullWidth: '全角文字である必要があります',
    halfWidth: '半角文字のみ',
    hash: 'ハッシュ コードはアルゴリズム {0} と一致しません',
    hexColor: '16 進数のカラー コードである必要があります',
    hex: '16 進数でなければなりません',
    identityCard: '有効な ID カード番号である必要があります',
    creditCard: '有効なクレジット カード番号である必要があります',
    fqdn: '有効な FQDN である必要があります',
    ipOrFQDN: 'IP または FQDN である必要があります',
    isbn: '有効なISBNである必要があります',
    issn: '有効な ISSN である必要があります',
    isin: '有効な ISIN である必要があります',
    iso8601: 'ISO8601 日付形式である必要があります',
    rfc3339: 'RFC3339 の日付形式である必要があります',
    iso31661Alpha2: 'ISO 3166-1 Alpha-2 公式に割り当てられた国コードでなければなりません',
    iso31661Alpha3: 'ISO 3166-1 Alpha-3 公式に割り当てられた国コードでなければなりません',
    json: 'JSON 形式の文字列である必要があります',
    jwt: '有効な JSON Web トークンである必要があります',
    latLong: '有効な緯度と経度の座標である必要があります。 (-17.738223、85.605469)',
    mobile: 'フォーマットエラー、再試行ください',
    mongoId: 'MongoDB ObjectId の有効な 16 進エンコード表現である必要があります',
    postalCode: '有効な郵便番号である必要があります',
    uuid: '有効な UUID である必要があります',
    chinese: '中国人に違いない',
};
//# sourceMappingURL=ja.js.map